import { render, staticRenderFns } from "./update-fields-modal.vue?vue&type=template&id=76cd1d1f&scoped=true&"
import script from "./update-fields-modal.vue?vue&type=script&lang=js&"
export * from "./update-fields-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd1d1f",
  null
  
)

export default component.exports